/**
 * Link icon options for activity links.
 * - Built-in options use Bootstrap Icons (bi-*).
 * - Account custom icons come from account.settings.images (type === 'icon') and use url.
 */

export const LINK_ICON_DEFAULT = '';

export const BUILT_IN_LINK_ICONS = [
  { value: '', labelKey: 'planDetail.activityModals.linkIconDefault', iconClass: 'bi-link-45deg' },
  { value: 'map', labelKey: 'planDetail.activityModals.linkIconMap', iconClass: 'bi-geo-alt' },
  { value: 'ticket', labelKey: 'planDetail.activityModals.linkIconTicket', iconClass: 'bi-ticket-perforated' },
  { value: 'globe', labelKey: 'planDetail.activityModals.linkIconGlobe', iconClass: 'bi-globe' },
  { value: 'calendar', labelKey: 'planDetail.activityModals.linkIconCalendar', iconClass: 'bi-calendar-event' },
  { value: 'bookmark', labelKey: 'planDetail.activityModals.linkIconBookmark', iconClass: 'bi-bookmark' },
];

/**
 * @param {Array<{ url: string, name: string, type: string }>} accountImages - account.settings.images
 * @returns {Array<{ value: string, label: string, labelKey?: string, iconClass?: string, iconUrl?: string }>}
 * Brand icons (custom) are listed FIRST so users can select their brand; then Default and built-in icons.
 */
export function getLinkIconOptions(accountImages = [], t) {
  const options = [];

  const customIcons = (accountImages || []).filter((img) => img.type === 'icon' && img.url);
  customIcons.forEach((img) => {
    options.push({
      value: img.url,
      label: img.name || img.url,
      iconUrl: img.url,
    });
  });

  BUILT_IN_LINK_ICONS.forEach((opt) => {
    options.push({
      value: opt.value,
      label: t ? t(opt.labelKey) : opt.value || 'Default',
      labelKey: opt.labelKey,
      iconClass: opt.iconClass,
    });
  });

  return options;
}

/**
 * Whether value is a built-in key (not a URL).
 */
function isBuiltInIconValue(value) {
  if (!value) return true;
  return BUILT_IN_LINK_ICONS.some((opt) => opt.value === value);
}

/**
 * Get icon class for built-in icon value.
 */
export function getBuiltInIconClass(value) {
  const found = BUILT_IN_LINK_ICONS.find((opt) => opt.value === value);
  return found ? found.iconClass : 'bi-link-45deg';
}

/**
 * Render props for a link icon: { iconClass } or { iconUrl } for custom.
 */
export function getLinkIconDisplay(link, accountImages = []) {
  const value = link?.icon ?? LINK_ICON_DEFAULT;
  if (!value) {
    return { iconClass: 'bi-link-45deg' };
  }
  if (isBuiltInIconValue(value)) {
    return { iconClass: getBuiltInIconClass(value) };
  }
  // Custom URL from account.settings.images
  return { iconUrl: value };
}
